// extracted by mini-css-extract-plugin
export default {"collapsible":"Faqs_collapsible__i5Y1r","answer":"Faqs_answer__C3TbU"};